import HttpService from './HttpService';

const ClientsApi = HttpService('/api/clients/');
const doPost = (action, data) => ClientsApi.post(action, data);
const doGet = (url) => ClientsApi.get(url);
const doDelete = (url) => ClientsApi.delete(url);

export default {
  getClients(activeSiteId) {
    const apiAction = 'GetClients';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createClient(client) {
    const apiAction = 'CreateClient';
    return doPost(apiAction, client);
  },
  updateClient(clientUpdate) {
    const apiAction = 'UpdateClient';
    return doPost(apiAction, clientUpdate);
  },
  deleteClient(id) {
    const apiAction = 'DeleteClient';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
};
